import ExcelJS from "exceljs";
import createStatementElement from "../../pages/survey/questions/create-statement-element";
import renumberStatements from "../../pages/survey/questions/renumber-statements";
import {showGenderColsIfBrandIsGenderSensitive as showGenderColsIfBrandIsGenderSensitiveStatement} from "./statements/show-gender-col";
import {showGenderColsIfBrandIsGenderSensitive as showGenderColsIfBrandIsGenderSensitiveWarmup} from "./warmups/show-gender-col";
import {showLockIconIfStatementsAreRotatable} from "./statements/show-lock-icon";
import {showGenderRow as showGenderRowStatement} from "./statements/show-gender-row";
import {showGenderRow as showGenderRowWarmup} from "./warmups/show-gender-row";
import createWarmupElement from "../../pages/survey/questions/create-statement-element";
import renumberWarmups from "../../pages/survey/questions/renumber-statements";

export async function readWorksheetsFromXlsx(file) {
    const blob = new Blob([file], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
    });
    const buffer = await blob.arrayBuffer();
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(buffer);

    return workbook.worksheets;
}

export function importStatementsFromSheet(worksheets, sheetIndex, $context) {
    const worksheet = worksheets[sheetIndex];
    worksheet.eachRow(function(row, rowNumber) {
        if (rowNumber > 1) {
            addStatement(row.values, $context, false)
        }
    });
    const rows = worksheet.getColumn(1);
    const rowsCount = rows['_worksheet']['_rows'].length - 1;
    $context.trigger('remove-first-statements', [rowsCount]);
}

export function importWarmupsFromSheet(worksheets, sheetIndex, $context) {
    const $warmupListPart = $context.find('.warmups-list-part');
    const minWarmupsCount = $warmupListPart.find('.item-position').length;
    removeAllWarmups($context, minWarmupsCount);
    worksheets[sheetIndex].eachRow(function(row, rowNumber) {
        if (rowNumber > 1) {
            addWarmup(row.values, $context)
        }
    });
    const importedWarmupsCount = $warmupListPart.find('.item-position').length;
    if (minWarmupsCount > importedWarmupsCount) {
        const addWarmupsCount = minWarmupsCount - importedWarmupsCount;
        for (let i = 1; i <= addWarmupsCount; i++) {
            $context.trigger('add-new-warmup');
        }
    }
}

function addStatement(statement, $context, reloadStatementsCount = true) {
    let $statementElement = createStatementElement($context.find('[data-statement-template]'), {
        male: {
            male: statement[1],
            female: statement[2],
        },
        female: {
            male: statement[3],
            female: statement[4],
        }
    });

    const statementListPart = $context.find('.statements-list-part');

    // check if brand is gender sensitive
    $statementElement = showGenderColsIfBrandIsGenderSensitiveStatement($statementElement, $context);

    // check if rotate statements switch is on
    $statementElement = showLockIconIfStatementsAreRotatable($statementElement, $context);

    if (undefined !== statement[2]) {
        $statementElement = showGenderRowStatement($statementElement);
    }

    $statementElement.appendTo(statementListPart);

    const $surveyStatements = $context.find('.surveyStatements');
    renumberStatements($surveyStatements);

    if (reloadStatementsCount) {
        $context.trigger('reload-statements-count');
    }
}

function removeAllStatements($context) {
    const statementsCount = $context.find('[data-statement-item]').length;
    $context.trigger('remove-last-statements', [statementsCount]);
}

function removeAllWarmups($context) {
    const warmupListPart = $context.find('.warmups-list-part');
    const warmupCount = $(warmupListPart).find('.item-position').length;
    $context.trigger('remove-last-warmups', [warmupCount]);
}

function addWarmup(warmup, $context) {
    const warmupListPart = $context.find('.warmups-list-part').get(0);
    let $warmup = createWarmupElement($context.find('[data-warmup-template]'), {
        male: {
            male: warmup[1],
            female: warmup[2],
        },
        female: {
            male: warmup[3],
            female: warmup[4],
        }
    }, '--warmup-ID--');

    // check if brand is gender sensitive
    $warmup = showGenderColsIfBrandIsGenderSensitiveWarmup($warmup, $context);

    if (undefined !== warmup[2]) {
        $warmup = showGenderRowWarmup($warmup);
    }

    $warmup.appendTo(warmupListPart);

    // renumber elements
    renumberWarmups($(warmupListPart));
}
